import { render, staticRenderFns } from "./gasprice.vue?vue&type=template&id=00ae672c&"
import script from "./gasprice.vue?vue&type=script&lang=js&"
export * from "./gasprice.vue?vue&type=script&lang=js&"
import style0 from "./gasprice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports